import type { ReactNode } from 'react'
import { Empty, EmptyHeader, EmptyTitle } from '../ui/empty'

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyTitle>{children}</EmptyTitle>
      </EmptyHeader>
    </Empty>
  )
}
